<svg viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.0005 3.40236L11.3325 2.80353C8.96494 0.681165 5.32306 0.757651 3.04632 3.03305C0.779981 5.30072 0.694634 8.92371 2.79059 11.2916L11.9977 20.5139L21.2071 11.2915C23.3027 8.92404 23.2194 5.30744 20.9509 3.03258C18.6771 0.75517 15.0281 0.684112 12.6681 2.80301L12.0005 3.40236Z" fill="white"/>
</svg>
